import { render } from "./OrderHistView.vue?vue&type=template&id=3813f4ca&scoped=true"
import script from "./OrderHistView.vue?vue&type=script&lang=js"
export * from "./OrderHistView.vue?vue&type=script&lang=js"

import "./OrderHistView.vue?vue&type=style&index=0&id=3813f4ca&scoped=true&lang=css"
import "./OrderHistView.vue?vue&type=style&index=1&id=3813f4ca&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3813f4ca"]])

export default __exports__